import React from "react";

interface FormPageLayoutProps {
  title: string;
  formId: string;
  applicationFormIdNumber?: number | null;
  children: React.ReactNode;
  description?: string;
}

const FormPageLayout: React.FC<FormPageLayoutProps> = ({
  title,
  formId,
  applicationFormIdNumber,
  children,
  description,
}) => {
  return (
    <div className="container mt-4">
      <h2 className="mb-3 text-center">{title}</h2>
      <p className="text-center text-muted mb-4">
        Hồ sơ ứng tuyển: {applicationFormIdNumber || formId}
      </p>
      {description && (
        <p className="text-center text-muted mb-4">{description}</p>
      )}
      {children}
    </div>
  );
};

export default FormPageLayout;
